(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["canard-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const inquirySelect = document.getElementById('ContactForm-inquiry-type')
    const orderNumberWrapper = document.getElementById('ContactForm-order-number-wrapper')
    const orderNumberInput = document.getElementById('ContactForm-order-number')

    if (!inquirySelect || !orderNumberWrapper || !orderNumberInput) return

    const toggleOrderNumberField = () => {
      const showOrderNumber = inquirySelect.value === 'Order Inquiry'
      orderNumberWrapper.hidden = !showOrderNumber
      orderNumberInput.disabled = !showOrderNumber
      orderNumberInput.required = showOrderNumber

      if (!showOrderNumber) orderNumberInput.value = ''
    }

    inquirySelect.addEventListener('change', toggleOrderNumberField)
    toggleOrderNumberField()
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["canard-mini-slideshow"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeGalleries = (root) => {
    const galleries = root.querySelectorAll('.image-gallery:not([data-gallery-initialized])');
    galleries.forEach((gallery) => {
      gallery.dataset.galleryInitialized = 'true';
      const viewport = gallery.querySelector('.image-gallery__viewport');
      const slides = [...gallery.querySelectorAll('.image-gallery__slide[data-slide-index]')];
      const count = gallery.querySelector('.image-gallery__count');
      if (!viewport || slides.length < 2) return;
      let current = 0;
      let timer;
      let animationFrame;
      let animating = false;
      const update = () => {
        const progress = viewport.clientWidth ? viewport.scrollLeft / viewport.clientWidth : 0;
        slides.forEach((slide, index) => {
          slide.style.opacity = String(1 - Math.min(1, Math.abs(progress - index)));
        });
        if (!animating) {
          current = Math.max(0, Math.min(slides.length - 1, Math.round(progress)));
          if (count) count.textContent = `${current + 1} / ${slides.length}`;
        }
      };
      const animateTo = (targetLeft) => {
        window.cancelAnimationFrame(animationFrame);
        const startLeft = viewport.scrollLeft;
        const distance = targetLeft - startLeft;
        const duration = Number(gallery.dataset.transitionDuration) || 700;
        let startTime;
        animating = true;
        viewport.classList.add('image-gallery__viewport--animating');
        const step = (time) => {
          startTime ??= time;
          const progress = Math.min((time - startTime) / duration, 1);
          const eased = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
          viewport.scrollLeft = startLeft + distance * eased;
          update();
          if (progress < 1) {
            animationFrame = window.requestAnimationFrame(step);
          } else {
            animating = false;
            viewport.classList.remove('image-gallery__viewport--animating');
            update();
          }
        };
        animationFrame = window.requestAnimationFrame(step);
      };
      const goTo = (index) => {
        current = (index + slides.length) % slides.length;
        const targetLeft = viewport.clientWidth * current;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.cancelAnimationFrame(animationFrame);
          animating = false;
          viewport.classList.remove('image-gallery__viewport--animating');
          viewport.scrollLeft = targetLeft;
        } else {
          animateTo(targetLeft);
        }
        if (count) count.textContent = `${current + 1} / ${slides.length}`;
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        const interval = Number(gallery.dataset.interval) || 5000;
        if (gallery.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => goTo(current + 1), interval);
        }
      };
      viewport.addEventListener('scroll', () => { window.requestAnimationFrame(update); }, { passive: true });
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goTo(current - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => goTo(current + 1));
      gallery.addEventListener('mouseenter', stop);
      gallery.addEventListener('mouseleave', start);
      gallery.addEventListener('focusin', stop);
      gallery.addEventListener('focusout', (event) => { if (!gallery.contains(event.relatedTarget)) start(); });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      start();
    });
    };
    initializeGalleries(document);
    document.addEventListener('shopify:section:load', (event) => initializeGalleries(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
